import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {CrystalClearFrontUrl} from '../../shared/pages/crystal-clear-front-url';
import {AppConfigService} from '../app-config.service';

@Injectable({providedIn: 'root'})
export class FeatureEnabledGuard implements CanActivate {
  constructor(private appConfigService: AppConfigService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const configFlag = route.data.configFlag as keyof AppConfigService;
    if (!configFlag || this.appConfigService[configFlag]) {
      return true;
    }
    return this.router.parseUrl(CrystalClearFrontUrl.HOME.path);
  }
}
